module.exports = __webpack_public_path__ + "img/T5-D-xh_0.067da6b0.png";